export const VossProductType = { Main: 0, Addon: 1, License: 2, Usage: 3 } as const;
export type VossProductType = (typeof VossProductType)[keyof typeof VossProductType];

export const VossProductTypeText: Record<number, string> = {
    [VossProductType.Main]: 'vossProductType.main',
    [VossProductType.Addon]: 'vossProductType.addon',
    [VossProductType.License]: 'vossProductType.license',
    [VossProductType.Usage]: 'vossProductType.usage',
};

export const VossProductTypeOptions = Object.entries(VossProductType).map(([name, id]) => ({ id, name, nameKey: VossProductTypeText[id] }));
